<template>
  <button class="button" :class="{ 'button--disabled': hidden }">
    {{ title }}
  </button>
</template>

<script>
import MixinMediaQuery from "@/services/mixins/mediaQuery";

export default {
  name: "VButton",
  props: {
    title: String,
    hidden: Boolean
  },
  mixins: [MixinMediaQuery]
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.button {
  width: 18vw;
  height: 9vw;
  font-size: 2.5vw;
  @media #{$large-and-up} {
  width: 10vw;
  height: 6vw;
  font-size: 1.5vw;
  }
  padding: 16px 24px;
  border-radius: 8px;
  border: none;
  outline: none;
  background: #fff;
  box-shadow: 0px 8px 8px rgba(224, 224, 224, 0.2);
  color: #242424;
  &--disabled {
    visibility: hidden;
  }
}
</style>
